'use client'
import { useUser } from '@/src/store/user-store'
import { Box, Button, Flex, Icon, Text } from '@chakra-ui/react'
import Link from 'next/link'
import { FaArrowRightLong } from 'react-icons/fa6'

export default function NoEarningsYet({
  type,
}: {
  type: 'viewer' | 'creator' | 'redemption' | 'all'
}) {
  const { user } = useUser()
  return (
    <Flex w="100%">
      <Box
        backgroundImage={[
          'url("/subscriptions/nosub-mobile.svg")',
          'url("/subscriptions/nosub-mobile.svg")',
          'url("/subscriptions/nosub-desktop.svg")',
        ]}
        backgroundPosition={'center'}
        backgroundRepeat={'no-repeat'}
        backgroundSize={'cover'}
        w="100%"
        maxW="1000px"
        mx="auto"
        zIndex={2}
        display="flex"
        flexDir="column"
        height={['500px', '500px', '600px', '700px']}
      >
        <Box
          px={[4, 4, 4]}
          display="flex"
          alignItems={['center', 'center', 'flex-start']}
          pb={20}
          pt={[0, 0, 32]}
          justifyContent="center"
          flex="1"
          w="100%"
          gap={6}
        >
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            flex="1"
            flexDir={'column'}
          >
            <Text
              textAlign={'center'}
              fontSize={['xl', 'xl', '2xl']}
              fontWeight="bold"
              maxW={96}
            >
              {type == 'all' && 'Uh Oh! Looks like you have no earnings yet.'}
              {type == 'creator' &&
                "Looks like you haven't earned from creating videos yet!"}
              {type == 'redemption' &&
                "You haven't redeemed any LYK coins yet!"}
              {type == 'viewer' &&
                "Looks like you haven't earned from watching videos yet!"}
            </Text>
            <Text textAlign={'center'} mt={2} maxW={96}>
              {type == 'all' &&
                'More you watch and create, more earnings you add to your wallet!'}
              {type == 'creator' && 'Start creating to start earning!'}
              {type == 'redemption' &&
                'A minimum balance of 100 LYK coins is needed to redeem your balance. Start earning!'}
              {type == 'viewer' &&
                'More you watch, more you add watch time earnings to your wallet!'}
            </Text>
            <Flex gap={4} mt={5} flexWrap="wrap">
              <Button
                bg="lyk-green"
                color="white"
                _hover={{ bg: 'lyk-green' }}
                rightIcon={<Icon as={FaArrowRightLong} />}
                size="sm"
                px={8}
                py={6}
                as={Link}
                flex={1}
                minW="170px"
                href="/home"
              >
                Explore content
              </Button>
              <Button
                minW="170px"
                bg="lyk-red"
                color="white"
                _hover={{ bg: 'lyk-red' }}
                rightIcon={<Icon as={FaArrowRightLong} />}
                size="sm"
                px={8}
                py={6}
                as={Link}
                flex={1}
                href={'/c/' + user?.channelShareName + '?upload=true'}
              >
                Upload a video
              </Button>
            </Flex>
          </Box>
        </Box>
      </Box>
    </Flex>
  )
}
